import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import MyPATFileUpload from '../../../../common/MyPATFileUpload';
import Link from '@material-ui/core/Link';
import { Grid, withStyles, WithStyles } from '@material-ui/core';
import { styles } from './style';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import { MyPATDialog, MyPATSelect } from '../../../../common';
import SearchBarWithChips from '../../../common/SearchBarWithChips';
import classNames from "classnames";
import * as courseManagementActions from "../../../actions/courseManagementActions";
import {Package, Template, TestDetail, TestSeriesCoursePlan} from "../../../types/interfaces/CourseBasicDetails"
import _ from 'lodash';
import MyPATUploader, { Attachment } from '../../../../common/MyPATUploader';
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem } from '../../../../common/MyPATUploadPreview';
import { Error } from "@material-ui/icons";
import DropZone from '../../../../common/DropZone';
import { FAQ_SAMPLE_FILE_URL, SCHEDULE_TEST_SAMPLE_FILE_URL } from '../../../Constants/constants';
import * as XLSX from 'xlsx';
import { showMsg as showAlert } from "../../../../course/actions/loaderAlert";

enum sheetColumnsNames {
  sequenceNo= "Sequence No.",
  question= "Question",
  answer= "Answer",
}

interface UploadFAQPopUpState {
    open: boolean;
    attachments: Attachment[];
}

interface UploadFAQPopUpProps extends WithStyles<typeof styles>{
  classes: any,
  open: boolean,
  onClose: any;
  onDone: any;
  showAlert: Function;
}

const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
    "doc",
    "docx",
    "xls",
    "xlsx",
    "msword",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
class UploadFAQPopUp extends React.Component <UploadFAQPopUpProps, UploadFAQPopUpState>{
  upload: any = null;
  constructor(props:any) {
    super(props);
    this.state = {
        open: false,
        attachments: [],
      };
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  setAttachments = (attachments: Attachment[]) => {
    this.setState({
      attachments,
    });
  };

  handleDownloadClick = () => {
    const url: string=FAQ_SAMPLE_FILE_URL
    window.open(url, "_blank");
  };

  handleFile = (Files:Attachment[]) => {
    //console.log("Files",Files);
    this.props.onClose();
   this.readExcel(Files[0]);
  };

  readExcel = (file:any) => {
    const promise = new Promise((resolve:any, reject:any) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e:any) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, {type:'buffer'});

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        //console.log(data)

        resolve(data);

        fileReader.onerror=((error)=>{
          reject(error)
        })
      }
    });

    promise.then((d) => {
    //   //console.log(d)
    //   this.filterTestSeriesData(d);
      this.props.onDone(d);
    })
  }

  render() {
    const { open, attachments } = this.state; 
    const { classes } = this.props;
    return (
      <div>
        {/* <Button variant='contained' color='primary' onClick={this.handleClickOpen}>
          Add schedued test dialog
        </Button> */}
        <span className={classes.customFileBrowse} onClick={this.handleClickOpen}>
                {/* <input type='file' id='file' /> */}
                <label 
                // htmlFor='file' 
                className={[classes.linkCTA, classes.mb18].join(' ')}>
                  <CloudUploadOutlinedIcon />
                  &nbsp; Add Scheduled Tests
                </label>
        </span>
        <MyPATDialog
          onClose={this.props.onClose}
          // aria-labelledby='customized-dialog-title'
        //   open={this.props.open}
          // fullWidth={true}
          dialogOpen={this.props.open}
          dialogHasActions={true}
          dialogHeading={
            <>
              <span className={classes.requestDialogTitle}>
              Upload File
              </span>
            </>
          }
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.props.onClose}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: 'sm',
          }}
        >
           
        
            <Grid container justify="center">
                
                    <div style={{width: '100%'}}>
                      <MyPATUploader
                        onChange={this.setAttachments}
                        allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                        initialAttachments={attachments}
                      >
                        {({
                          onItemRemove,
                          attachments,
                          loading,
                          errorMsg,
                          error,
                          handleFileChange,
                        }) => {
                          //console.log({ attachments });
                          const list = attachments.map((attachment) =>
                            convertFileOrUrlToPreviewItem(attachment)
                          );
                          return (
                            <>
                              {attachments.length > 0 ? (
                                <Grid className={classes.uploadPreview}>
                                  <MyPATUploadPreview
                                    list={list}
                                    readOnly={false}
                                    onItemRemove={onItemRemove}
                                  />
      
                                  {error && (
                                    <Grid item xs={12} justify="center">
                                      <Typography
                                        className={classes.errorText}
                                        variant="caption"
                                        color="error"
                                      >
                                        <Error />
                                        {errorMsg}
                                      </Typography>
                                    </Grid>
                                  )}
                                </Grid>
                              ) : (
                                <DropZone onChange={handleFileChange}>
                                    <Grid container justify="center" className={classes.manageContainer}>
                                      <div className={classes.dragDropVideoContainer}>
                                        <Grid container justify="center">
                                          <div style={{ width: "100%" }}>
                                            <img
                                              alt="Cancel video upload"
                                              src="/assets/svg/learn/cloudUpload.svg"
                                              onClick={(e) => {
                                                this.upload.value = "";
                                                this.upload.click();
                                              }}
                                              style={{ cursor: "pointer" }}
                                            />
                                          </div>
                                          <Typography
                                            className={classes.dragDropVideoText}
                                            component="div"
                                            variant="body1"
                                            align="center"
                                          >
                                            {false
                                              ? "uploading"
                                              : "Drag and drop a file"                                         
                                            }
                                            <span className={classes.fileInfo}>Only upload .csv with max size 2 MB</span>
                                          </Typography>
                                          <input
                                            id="myInput"
                                            type="file"
                                            ref={(ref) => (this.upload = ref)}
                                            onChange={(event: any) => {
                                              //console.log(event);
                                              //  let event={target:{files:this.upload}};
                                              handleFileChange(event);
                                            }}
                                            style={{ display: "none" }}
                                          />
                                        </Grid>
                                      </div>
                                    </Grid>
                                </DropZone>
                              )}
                            </>
                          );
                        }}
                      </MyPATUploader>
                      <div className={classes.fileTypeInfo}>
                        Kindly upload data only in the sample format .CSV
                      </div>
                      <div className={classes.downloadSample}>
                        <a onClick={this.handleDownloadClick}><img alt="Download" src="/assets/svg/learn/downloadIcon.svg"/> Download Sample Format</a>
                        {/* <Link href="../../../../../ScheduleCreate(3).xlxs" target="_blank" download>Download Sample Format</Link> */}
                      </div>
                      <Grid container justify="center">
                        <Button
                          variant="contained"
                          color="primary"
                          style={{
                            marginTop: "13px",
                          }}
                          onClick={()=>{this.handleFile(attachments)}}
                          disabled={attachments.length===0}
                        >
                          Upload File
                        </Button> 
                      </Grid>
                    </div>
                  
                
            </Grid>
        </MyPATDialog>
      </div>
    );
  }
}

// export default withStyles(styles)(AddScheduledTest);


const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showAlert
    },
    dispatch
  )


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
) (withStyles(styles)(UploadFAQPopUp));
